<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              Пакеты платежных поручения на комиссию партнеров
            </div>
            <div class="row mt-3">
              <div @click="showCreatePackage()" class="btn btn-sm btn-success">
                <i class="fas fa-plus"></i> Создать новый пакет
              </div>
              <div class="col-lg-12">
                <table class="table table-hover" style="cursor: pointer;">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Дата ПП</th>
                    <th>Дата начала периода</th>
                    <th>Дата окончания периода</th>
                    <th>Время формирования</th>
                    <th>Действия</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in this.partnerProfitOrderPackagesData" :key="item.id">
                    <td>{{item.id}}</td>
                    <td>{{item.date ? new Date(item.date).toLocaleDateString('ru-RU') : ''}}</td>
                    <td>{{item.start_period ? new Date(item.start_period).toLocaleDateString('ru-RU') : ''}}</td>
                    <td>{{item.end_period ? new Date(item.end_period).toLocaleDateString('ru-RU') : ''}}</td>
                    <td>{{new Date(item.updated_at * 1000).toLocaleString('ru-RU')}}</td>
                    <td>
                      <div @click="showForExport(item)" class="btn btn-sm btn-outline-success">
                        <i class="fas"></i> Развернуть
                      </div>
                      <div @click="showDeletePackage(item)" class="btn btn-sm btn-outline-danger">
                        <i class="fas"></i> Удалить
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <popup
        :closeButton="createPackage.closeButton"
        :actionButton="createPackage.actionButton"
        :actionClass="createPackage.actionClass"
        :show="createPackage.show"
        @closePopup="closeCreatePackage"
        @actionPopup="generatePackage"
    >
      <div slot="header">Создание пакета платежных поручений</div>
      <div slot="body">
        <CreateMassPartnerProfitOrderPackage
            ref="myChildCreatePackage"
            @package-created="packageCreated"
        >
        </CreateMassPartnerProfitOrderPackage>
      </div>
    </popup>

    <popup
        :closeButton="deletePackage.closeButton"
        :actionButton="deletePackage.actionButton"
        :actionClass="deletePackage.actionClass"
        :show="deletePackage.show"
        @closePopup="closeDeletePackagePopup"
        @actionPopup="confirmDeletePackage"
    >
      <div slot="header">Вы действительно хотите удалить пакет и все входящие в него платежки?</div>
      <div slot="body">
        <DeleteMassPartnerProfitOrderPackage
            ref="myChildDeletePackage"
            @package-deleted="eventPackageDeleted"
        >
        </DeleteMassPartnerProfitOrderPackage>
      </div>
    </popup>

    <popup
        :closeButton="viewPackage.closeButton"
        :show="viewPackage.show"
        @closePopup="closeViewPackage"
    >
      <div slot="header">Сформированный пакет платежек</div>
      <div slot="body">
        <ViewPartnerProfitOrderPackage  ref="myChildViewPartnerProfitOrderPackage">
        </ViewPartnerProfitOrderPackage>
      </div>
    </popup>

  </div>

</template>

<script>

import axios from "axios";
import CreateMassPartnerProfitOrderPackage from "./CreateMassPartnerProfitOrderPackage.vue"
import Popup from "@/components/Popup.vue";
import ViewPartnerProfitOrderPackage from "@/components/management/partners/ViewPartnerProfitOrderPackage.vue";
import DeleteMassPartnerProfitOrderPackage
  from "@/components/management/partners/DeleteMassPartnerProfitOrderPackage.vue";

export default {
  name: "PartnerProfitOrderPackageList",
  components: {
    DeleteMassPartnerProfitOrderPackage,
    ViewPartnerProfitOrderPackage, CreateMassPartnerProfitOrderPackage, Popup},
  mounted() {
    this.setNullFormData();
  },
  props: {
    submitManagePartnerPrinters: Number
  },
  watch: {
  },
  data() {
    return {
      hasFreePrinters: null,
      createPackage: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },

      deletePackage: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.delete'),
        actionClass: "btn-success"
      },

      viewPackage: {
        show: false,
        closeButton: this.$t('popularWords.close'),
      },

      partnerProfitOrderPackagesData: [
          {
            id: null,
            date: null,
            start_period: null,
            end_period: null,
            updated_at: null,
            status: null,
          }
      ],
    }
  },

  methods: {
    getPackagesData() {
      axios
          .get(`/v1/mass-partner-profit-order-packages/get-all`)
          .then(resp => {
            this.partnerProfitOrderPackagesData = resp.data;
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    getPackageProfitOrders(id) {
      axios
          .get(`/v1/mass-partner-profit-order-packages/get-profit-orders?id=` + id)
          .then(resp => {
            this.partnerProfitOrderPackagesData = resp.data;
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    setNullFormData() {
      this.partnerProfitOrderPackagesData = null;    },

    showCreatePackage(){
      console.log(this.hasFreePrinters);
      if (
          (
              this.hasFreePrinters
              && confirm('Имеются непривязанные принтеры. Вы действительно хотите сформировать пакет платежек?')
          )
          || !this.hasFreePrinters
      ) {
        this.$refs.myChildCreatePackage.setNullFormDate();
        this.createPackage.show = true;
      }

    },
    closeCreatePackage(){
      this.createPackage.show = false;
    },
    generatePackage(){
      this.$refs.myChildCreatePackage.generatePackage();
      this.getPackagesData();
      this.closeCreatePackage();
    },
    showForExport(orderPackage){
      axios
          .get(`/v1/mass-partner-profit-order-packages/get-profit-orders?id=` + orderPackage.id)
          .then(resp => {
            this.$refs.myChildViewPartnerProfitOrderPackage.ppDataObjects = resp.data;
            axios
                // Забираем с бэка данные пакета для шапки простыни
                .get(`/v1/mass-partner-profit-order-packages/get-one-short?id=` + orderPackage.id)
                .then(resp => {
                  this.$refs.myChildViewPartnerProfitOrderPackage.packageData = resp.data;
                  this.$refs.myChildViewPartnerProfitOrderPackage.generateAreaContent();
                })
                .catch(err => {
                  this.$store.dispatch("addNotification", {
                    text: err.response.data.message,
                    time: 6,
                    color: "danger"
                  });
                });
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });

      this.viewPackage.show = true;
    },
    closeViewPackage(){
      this.viewPackage.show = false;
      this.$refs.myChildViewPartnerProfitOrderPackage.setNullFormData();
    },
    packageCreated: function (data) {
      this.getPackagesData();
      alert('Создан пакет из ' + data.quantity + ' платежек, на общую сумму ' + data.sum);
    },
    showDeletePackage(currentPackage) {
      this.$refs.myChildDeletePackage.setCurrentPackageData(currentPackage.id, currentPackage.date)
      this.deletePackage.show = true;
    },
    closeDeletePackagePopup() {
      this.deletePackage.show = false;
    },
    confirmDeletePackage() {
      this.$refs.myChildDeletePackage.deletePackage()
    },
    eventPackageDeleted () {
      this.getPackagesData();
      this.closeDeletePackagePopup();
    }
  }
}
</script>

<style scoped lang="scss">

</style>